export const ERROR_REQUIRED_FIELD = 'This field is required.';
export const ERROR_REQUIRED_FIELD_WITH_NAME = (fieldName: string) => `${fieldName} is required.`;
export const ERROR_MIN_LENGTH = (min: number) =>
  `This field must be at least ${min} characters long`;
export const ERROR_MAX_LENGTH = (max: number) =>
  `This field must be at most ${max} characters long`;
export const ERROR_INVALID_FORMAT = 'This format is invalid.';
export const ERROR_UNEXPECTED = 'An unexpected error occurred.';
export const ERROR_INVALID_EMAIL = 'Please use a valid ST Engineering email address.';
export const ERROR_CHOOSE_DECISION = 'Please choose a decision before submitting';
export const ERROR_PASSWORD_MISMATCH = 'Passwords do not match.';
export const ERROR_PASSWORD_USED_BEFORE =
  'This password has been used before. Please choose a different password.';
export const ERROR_PASSWORD_RESET_LIMIT =
  'You have reached your password reset limit for today. Please try again in 24 hours.';
